export const prefix = "weather_";
export const STORAGE_KEYS = {
  KEY_ID: "keyId",
  KEY_AID: "keyAid",
  KEY_BID: "keyBid",
  KEY_CID: "keyCid",
  KEY_DID: "keyDid",
  INFO: "info",
  API_ALL: "apiAll",
  AWS_CON: "awsCon",
  SELECT_CITY: "select_city",
  TIME_ZONE: "time_zone",
  LAT: "latitude",
  LONG: "longitude",
  HEADER2: "header2",
};
